const updateCheckboxVisibilityForUX1Country = locale => {
  const checkboxWrapper = document.querySelectorAll(".checkbox");
  const UX1Countries = ["in", "us", "mx"];
  if (UX1Countries.indexOf(locale) > -1) {
    checkboxWrapper.forEach(each => {
      each.style = "display:none";
    });
  } else {
    checkboxWrapper.forEach(each => {
      const checkboxSelect = each.querySelector("input[type=checkbox]");
      if (checkboxSelect.name === "optinDataCollection") {
        checkboxSelect.required = true;
        checkboxSelect.oninvalid = function() {
          each.className += " required";
        };
      }
    });
    const formPrivacyWrapper = document.querySelector(".form-privacy");
    formPrivacyWrapper.style = "display:none";
  }
};

export default updateCheckboxVisibilityForUX1Country;



// WEBPACK FOOTER //
// ./src/assets/js/updateCheckboxVisibilityForUX1Country.js